import { Suspense } from 'react';
import { ReactNode } from 'react';
import { PostcodePrompt } from './search/postcode-prompt';
import { P2GDivider, P2GGrid } from '@parcel2go/core-ui';
import QuotePromotions, { CmsPromotion } from './promotions/quote-promotions';
import QuoteResults from './results/quote-results';
import { QuoteFilterOptions } from '~/lib/quotes';
import { BasketQuote, QuoteParcel, QuoteExtra } from '~/lib/types/basket-types';
import QuoteResultHeading from './results/quote-results-heading';
import { ShopProviders } from '~/lib/types/edge-api-types';

const QuotesList = ({
  children,
  onReset,
  filter,
  onSelect,
  onPromotionSelect,
  loading,
  origin,
  destination,
  parcels,
  filteredQuotes,
  postcode,
  shops,
  geo,
  onGeoChange,
  hideLastUsed,
  onUpdatePostcode,
  currentSelectedExtras
}: {
  children?: ReactNode;
  onReset: () => void;
  filter: QuoteFilterOptions;
  loading: boolean;
  hideLastUsed?: boolean;
  onSelect: (index: number, quote: BasketQuote, extras: string[]) => void;
  onPromotionSelect?: (index: number, promotion: CmsPromotion, extras: string[]) => void;
  origin?: string;
  destination?: string;
  parcels?: QuoteParcel[];
  filteredQuotes: BasketQuote[];
  postcode?: string;
  shops: ShopProviders;
  geo: boolean;
  onGeoChange: (useGeo: boolean) => void;
  onUpdatePostcode: (postcode: string) => void;
  currentSelectedExtras?: QuoteExtra[];
}) => (
  <>
    <PostcodePrompt
      dataTestId="postcode-prompt"
      postcode={postcode}
      onSubmit={onUpdatePostcode}
      onCancel={onReset}
      showPostcode={!postcode && filter.sortType === 'Closest'}
    />
    <P2GGrid container direction="column" gap={3} wrap="nowrap">
      {onPromotionSelect && (
        <Suspense>
          <QuotePromotions
            incVat={!!filter.incVat}
            origin={origin}
            destination={destination}
            parcels={parcels}
            quotes={filteredQuotes}
            onClick={onPromotionSelect}
            wrapper={(x) => (
              <Suspense>
                <P2GGrid item>
                  <QuoteResultHeading translationKey="RESULT_PROMOTION_TITLE" defaultValue="Popular Services" />
                </P2GGrid>
                <P2GGrid item>{x}</P2GGrid>
              </Suspense>
            )}
          />
        </Suspense>
      )}
      {children && (
        <>
          <P2GGrid item>{children}</P2GGrid>
          <P2GGrid item>
            <P2GDivider />
          </P2GGrid>
        </>
      )}
      <P2GGrid item>
        <QuoteResults
          origin={origin}
          destination={destination}
          incVat={!!filter.incVat}
          loading={loading}
          quotes={filteredQuotes}
          onQuoteClick={onSelect}
          shops={shops}
          onEnabledGeoLocation={() => onGeoChange(!geo)}
          filter={filter}
          hideLastUsed={hideLastUsed}
          currentSelectedExtras={currentSelectedExtras}
        />
      </P2GGrid>
    </P2GGrid>
  </>
);

export default QuotesList;
